export default __webpack_public_path__ + "cb0b816e45ceb12cf1cdb35a7b4b5a5e.png";